import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'

const BASE = '/hanh-chinh/bao-tri-tai-san'

// Lấy chi tiết lịch bảo trì
export function layChiTietLichBaoTri(id: number) {
  try {
    return axiosApi.get(`${BASE}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo lịch bảo trì
export function taoLichBaoTri(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật lịch bảo trì
export function capNhatLichBaoTri(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách lịch bảo trì sắp tới
export function layDanhSachLichBaoTriSapToi() {
  try {
    return axiosApi.get(`${BASE}/sap-toi`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

/** Backend hiện chưa khai báo DELETE; giữ endpoint convention để bổ sung sau */
export function xoaLichBaoTri(id: number) {
  try {
    return axiosApi.delete(`${BASE}/${id}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
